import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  header: {
    id: 'containers.statistics.header',
    defaultMessage: 'Review your <strong>statistics</strong>',
  },
  days: {
    id: 'containers.statistics.days',
    defaultMessage: 'days',
  },
  date: {
    id: 'containers.statistics.date',
    defaultMessage: 'Date',
  },
  domain: {
    id: 'containers.statistics.domain',
    defaultMessage: 'Domain',
  },
  registrar: {
    id: 'containers.statistics.registrar',
    defaultMessage: 'Registrar',
  },
  price: {
    id: 'containers.statistics.price',
    defaultMessage: 'Price',
  },
  priceTooltip: {
    id: 'containers.statistics.priceTooltip',
    defaultMessage: 'Approximate value',
  },
  commision: {
    id: 'containers.statistics.commision',
    defaultMessage: 'Commision',
  },
  commisionTooltip: {
    id: 'containers.statistics.commisionTooltip',
    defaultMessage: 'Approximate value',
  },
  status: {
    id: 'containers.statistics.status',
    defaultMessage: 'Status',
  },
  loading: {
    id: 'containers.statistics.loading',
    defaultMessage: 'Loading…',
  },
  noData: {
    id: 'containers.statistics.noData',
    defaultMessage: 'No rewards yet',
  },
});



// WEBPACK FOOTER //
// ./src/containers/Statistics/messages.js